import {
  CollapseCommon,
  ToolbarProduct,
  UploadImageCommon,
  ProductAttributeSection,
  AddUnitCost,
  ProductSpecificationSection,
  ProductInfoSection,
  ModalConfirm,
  StickyToolbarWrapper,
} from 'components/common';
import React from 'react';
import { Layout } from 'antd';
import { ManageProductComponentProps } from 'types';
import { useWatch } from 'antd/es/form/Form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useManageProduct } from 'hooks/useManageProduct';
import ProductTabNavigation from './ProductTabNavigation/ProductTabNavigation';
import { tabButtonClass, tabSpanClass } from 'utils/tabButton';
import WarehouseCardProduct from './WarehouseCardProduct/WarehouseCardProduct';

const { Content } = Layout;

const ManageProductComponent: React.FC<ManageProductComponentProps> = ({
  form,
  onSubmit,
  isDetail = false,
  defaultIsEdit = true,
  isLoading,
  choiceVersion,
  onConfirm,
  onCancel,
  onReplaceVersion,
  onActive,
  initialProductUnits = [],
  initialProductAttributes = [],
  initialProductSalePrices = [],
  initialProductSuppliers = [],
}) => {
  const navigate = useNavigate();
  const [isCreateProductProcessed] = React.useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const queryParam = searchParams.get('query');
  const active = ['CTSP', 'TK'].includes(queryParam!) ? queryParam! : 'CTSP';
  // Use the extracted hook
  const {
    checkActive,
    setCheckActive,
    checkInactive,
    setInactive,
    checkUpdate,
    barcode,
    listVersion,
    productUnits,
    setProductUnits,
    productAttributes,
    setProductAttributes,
    productSalePrices,
    setProductSalePrices,
    productSuppliers,
    setProductSuppliers,
    modalOpen,
    setModalOpen,
    version,
    setVersion,
    isEdit,
    statusSave,
    setStatusSave,
    imagesData,
    setImagesData,
    filteredBrands,
    prefixCode,

    suppliers,
    getBrandsByCategoryIds,
    categories,
    units,
    attributes,
    code,
    isPublishId,
    isDraftId,
    isInactiveId,

    isLoadingBrands,
    isLoadingCategories,

    handleBarcode,
    handleCreatecode,
    handleCategoryChange,
    handleCheckUpdte,
    brands,
  } = useManageProduct({
    form,
    isDetail,
    defaultIsEdit,
    initialProductUnits,
    initialProductAttributes,
    initialProductSalePrices,
    initialProductSuppliers,
  });
  return (
    <Layout className='relative'>
      <Content className='py-4 px-6 bg-[var(--bgGreyEy)]'>
        <StickyToolbarWrapper stickyTop={56}>
          <ToolbarProduct
            setIsActive={setCheckActive}
            onReplaceVersion={onReplaceVersion}
            isActive={checkActive}
            checkInactive={checkInactive}
            barcode={code || form.getFieldValue('code')}
            isDetail={isDetail}
            isEdit={isEdit}
            isLoading={isLoading}
            nameProduct={useWatch('name', form) || form.getFieldValue('name')}
            version={version}
            listVersion={listVersion}
            checkUpdate={checkUpdate}
            setVersion={setVersion}
            choiceVersion={choiceVersion}
            onInactive={() => {
              onSubmit(
                { productUnits, productAttributes, imagesData, productSalePrices, productSuppliers },
                false,
                isInactiveId,
                checkActive,
                setModalOpen,
                setStatusSave,
                checkUpdate,
                version,
                true,
              );
              setInactive(true);
            }}
            setCheckUpdateVersion={handleCheckUpdte}
            onActive={(checked) =>
              onActive?.({ productUnits, productAttributes, imagesData, productSalePrices, productSuppliers }, checked)
            }
            onSaveDraft={() => {
              onSubmit(
                { productUnits, productAttributes, imagesData, productSalePrices, productSuppliers },
                false,
                isDraftId,
                checkActive,
                setModalOpen,
                setStatusSave,
                checkUpdate,
                version,
              );
            }}
            onPublish={() => {
              onSubmit(
                { productUnits, productAttributes, imagesData, productSalePrices, productSuppliers },
                true,
                isPublishId,
                checkActive,
                setModalOpen,
                setStatusSave,
                checkUpdate,
                version,
              );
            }}
            onCancel={() => {
              form.resetFields();
              navigate('/items/products');
            }}
          />
        </StickyToolbarWrapper>
        <ProductTabNavigation
          tabButtonClass={tabButtonClass}
          tabSpanClass={tabSpanClass}
          id={form?.getFieldValue('code')}
          activeKey={active || 'CTSP'}
        />
        {active === 'TK' ? (
          <>
            <WarehouseCardProduct />
          </>
        ) : (
          <>
            {/* Product sections */}
            <ProductInfoSection
              form={form}
              isEdit={isEdit}
              units={units?.data?.rows || []}
              isInactive={checkInactive}
              categories={categories?.data?.rows || []}
              suppliers={suppliers?.data?.rows || []}
              filteredBrands={filteredBrands}
              isLoadingCategories={isLoadingCategories}
              isLoadingBrands={isLoadingBrands}
              barcode={barcode}
              handleBarcode={handleBarcode}
              handleCreatecode={handleCreatecode}
              handleCategoryChange={handleCategoryChange}
              isDetail={isDetail}
              prefixCode={prefixCode}
              productSuppliers={productSuppliers}
              setProductSuppliers={setProductSuppliers}
              getBrandsByCategoryIds={getBrandsByCategoryIds}
            />

            {/* Other sections */}
            <ProductSpecificationSection
              form={form}
              isEdits={isEdit && !checkInactive}
              buttonName={'Thêm đơn vị đặc thù'}
              isEdit={isEdit && !checkInactive}
              isInactive={checkInactive}
              productUnits={productUnits}
              units={units?.data?.rows.filter((unit) => unit.type === 'unit') || []}
              setProductUnits={setProductUnits}
              isDetail={isDetail}
            />

            <AddUnitCost
              buttonName='Thêm định mức'
              productSalePrices={productSalePrices}
              setProductSalePrices={setProductSalePrices}
              isEdits={isEdit && !checkInactive}
              isInactive={checkInactive}
              form={form}
              units={units?.data?.rows.filter((unit) => unit.type === 'unit') || []}
            />

            {!isCreateProductProcessed && (
              <ProductAttributeSection
                isEdit={isEdit}
                isInactive={checkInactive}
                attributes={attributes?.data?.rows || []}
                productAttributes={productAttributes}
                setProductAttributes={setProductAttributes}
              />
            )}

            <CollapseCommon collapseKey='2' title='Đính kèm hình ảnh sản phẩm'>
              <UploadImageCommon
                imagesData={imagesData}
                setImagesData={setImagesData}
                isDisabled={!isEdit || checkInactive}
              />
            </CollapseCommon>
          </>
        )}
      </Content>

      <ModalConfirm
        open={modalOpen}
        setOpen={setModalOpen}
        onConfirm={() => onConfirm(setInactive)}
        checkInactive={checkInactive}
        isLoading={isLoading}
        isDetail={false}
        onCancel={onCancel}
        form={form}
        units={units?.data?.rows || []}
        setInactive={setInactive}
        productAttributes={productAttributes}
        productUnits={productUnits}
        productSalePrices={productSalePrices}
        statusSave={statusSave}
        imageMain={imagesData?.[0]?.filePath}
        suppliers={
          suppliers?.data?.rows.filter((supplier) => productSuppliers.some((item) => item === supplier.id)) || []
        }
        brand={brands?.data?.rows.find((brand) => brand.id === form.getFieldValue('brand'))}
        category={categories?.data?.rows.find((category) => category.id === form.getFieldValue('category'))}
      />
    </Layout>
  );
};

export default ManageProductComponent;
